// extracted by mini-css-extract-plugin
module.exports = {"divFlex":"orders_divFlex__3l9Qv","select1":"orders_select1__-9x17","radius":"orders_radius__Tp5eb","hidden_option":"orders_hidden_option__3y2mn","select2":"orders_select2__20MFp"};